import React from 'react';

/**
 * This file and the other files in the ./thirdparty folder are representative of the
 * react-google-recaptcha library which our Captcha was initially built upon. These files
 * are neceesary because a react-google-recaptcha dependency utilizes ES6 function calls not yet
 * supported in IE10 or IE11.
 *
 * This folder WILL BE REMOVED once we move to the new dependency system, and we will again
 * include the npm packages directly so as to abstract any recaptcha/react updates that may be
 * necessary
 *
 * Ticket to remove once on new dependency system: EB-56120
 */

//eslint-disable-next-line

import PropTypes from 'prop-types';

export default class ReCAPTCHA extends React.Component {
    constructor() {
        super();
        this.state = {};
    }

    componentDidMount() {
        this.explicitRender();
    }

    componentDidUpdate() {
        this.explicitRender();
    }

    getValue() {
        if (this.props.grecaptcha && this.state.widgetId !== undefined) {
            return this.props.grecaptcha.getResponse(this.state.widgetId);
        }
        return null;
    }

    execute() {
        const { grecaptcha } = this.props;
        const { widgetId } = this.state;

        if (grecaptcha && widgetId !== undefined) {
            return grecaptcha.execute(widgetId);
        }

        return null;
    }

    reset() {
        if (this.props.grecaptcha && this.state.widgetId !== undefined) {
            this.props.grecaptcha.reset(this.state.widgetId);
        }
    }

    handleExpired = () => {
        if (this.props.onExpired) {
            this.props.onExpired();
        } else if (this.props.onChange) {
            this.props.onChange(null);
        }
    };

    explicitRender(cb) {
        if (this.props.grecaptcha && this.state.widgetId === undefined) {
            //eslint-disable-next-line
            const id = this.props.grecaptcha.render(this.refs.captcha, {
                sitekey: this.props.sitekey,
                callback: this.props.onChange,
                theme: this.props.theme,
                type: this.props.type,
                tabindex: this.props.tabindex,
                'expired-callback': this.handleExpired,
                size: this.props.size,
                stoken: this.props.stoken,
                badge: this.props.badge,
            });

            this.setState(
                {
                    widgetId: id,
                },
                cb,
            );
        }
    }

    render() {
        // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
        const {
            sitekey,
            onChange,
            theme,
            type,
            tabindex,
            onExpired,
            size,
            stoken,
            grecaptcha,
            badge,
            ...childProps
        } = this.props;

        return (
            //eslint-disable-next-line
            <div {...childProps} ref="captcha" />
        );
    }
}

ReCAPTCHA.displayName = 'ReCAPTCHA';
ReCAPTCHA.propTypes = {
    sitekey: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    //eslint-disable-next-line
    grecaptcha: PropTypes.object,
    theme: PropTypes.oneOf(['dark', 'light']),
    type: PropTypes.oneOf(['image', 'audio']),
    tabindex: PropTypes.number,
    onExpired: PropTypes.func,
    size: PropTypes.oneOf(['compact', 'normal', 'invisible']),
    stoken: PropTypes.string,
    badge: PropTypes.oneOf(['bottomright', 'bottomleft ', 'inline']),
};
ReCAPTCHA.defaultProps = {
    theme: 'light',
    type: 'image',
    tabindex: 0,
    size: 'normal',
    badge: 'bottomright',
};
